<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-preface element-without-heading full-character-formatting" id="preface">
<div class="text" id="preface-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center">Some lives can be summed up in a sentence or two.</p>
<p class="alignment-block-content alignment-block-content-center">Other lives are epics.</p>
</div>
</div>
<hr class="implicit-break"/>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—<i>Clockwork Lives</i> by Kevin J. Anderson and Neil Peart</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// forthcoming.vue?055716a0